// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"31d6cfe0","222":"e28a6645","492":"6cccaf26","514":"394981ef","856":"da553554","883":"0e4cefa6"}[chunkId] + ".chunk.css";
};